import React from 'react';
export function Footer() {
  return <footer className="bg-ascension-black border-t border-white/5 py-12" data-id="element-90">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-91">
        <div className="flex flex-col items-center md:items-start gap-2" data-id="element-92">
          <div className="flex items-center gap-2" data-id="element-93">
            <div className="w-5 h-5 rounded bg-gradient-to-br from-ascension-green to-ascension-dark flex items-center justify-center" data-id="element-94">
              <div className="w-1.5 h-1.5 bg-white rounded-full" data-id="element-95" />
            </div>
            <span className="text-white font-semibold tracking-wide" data-id="element-96">
              Ascension
            </span>
          </div>
          <p className="text-sm text-ascension-gray" data-id="element-97">Habit Discipline System</p>
        </div>

        <div className="flex items-center gap-8 text-sm text-ascension-gray" data-id="element-98">
          <a href="#" className="hover:text-white transition-colors" data-id="element-99">
            Privacy
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-100">
            Terms
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-101">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}